import GreenButton from '../../components/green-button';
import PromotionsUtil from '../../../utils/promotions';
import ModalsLib from '../../../lib/modals';
import {navigate} from '../../../utils/navigation';

export default () => {
    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster promotion-modal promotion-invite">
            <div className="modal-header">
                <div className="close" onClick={e => {
                    PromotionsUtil.closePromotionModal('promotions-invite');
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="layer"><div className="girl"></div></div>
                <div className="layer">
                    <div className="content center">
                        <div className="top">
                            <div className="title">INVITE FRIENDS<br/>AND <span>EARN</span><br/>UP TO <span>$10,000</span></div>
                            <div className="descriptions">Invite your friends to <b>Lucksy</b> and earn money from it! We pay <b>up to 40%</b> from their deposits!</div>
                        </div>
                        <div className="center">
                            <div className="invite-stats">
                                <div className="invite-stats-title">

                                </div>
                            </div>
                        </div>
                        <div className="bottom">
                            <GreenButton onClick={e => {
                                PromotionsUtil.clickPromotionModals('promotions-invite', () => {
                                    ModalsLib.close();
                                    navigate('/invite');
                                });
                            }}>Invite friends</GreenButton>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}